import { render, staticRenderFns } from "./TranslationsHeader.vue?vue&type=template&id=0c9c02c2&scoped=true&"
import script from "./TranslationsHeader.vue?vue&type=script&lang=js&"
export * from "./TranslationsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TranslationsHeader.vue?vue&type=style&index=0&id=0c9c02c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c02c2",
  null
  
)

export default component.exports